import React, { ReactElement, useEffect, useState } from 'react';
import { Col, Heading, Row } from 'idsk-react-components';
import { useNavigate, useParams } from 'react-router';
import SavePripomienka from '../../../model/pripomienka/SavePripomienka';
import { useSuccessMessageContext } from '../../../context/SuccessMessageContext';
import { SafeParameterSetter } from '../../../types/SafeParameterSetter';
import { useClient } from '../../../context/ClientStatusContext';
import useFieldErrorMessages from '../../useFieldErrorMessages';
import routes from '../../../routing/routes';
import { useUserContext } from '../../../context/UserContext';
import { editPripomienka } from '../../../client/editPripomienkaClient';
import EditPripomienkaForm from './EditPripomienkaForm';
import PripomienkaDetailRow from '../../PripomienkaDetail/component/PripomienkaDetailRow';
import { useActionContext } from '../../../context/ConfirmActionContext';
import PripomienkaDetail from '../../../model/pripomienka/PripomienkaDetail';

interface Props {
  pripomienkaDetail: PripomienkaDetail
}

const EditPripomienkaComponent = ({
  pripomienkaDetail,
}: Props): ReactElement => {
  const {
    type,
    year,
    index,
    uuid,
    // @ts-ignore
  } = useParams<{ type: string, year: number, index: number, uuid: string }>();
  const navigate = useNavigate();
  const { legislationProcess } = useUserContext();
  const { displaySuccess } = useSuccessMessageContext();
  const [pripomienka, setPripomienka] = useState<SavePripomienka>({
    clanok: '',
    paragraf: '',
    odsek: '',
    celyMaterial: false,
    ine: '',
    text: '',
  });
  const { status, wrapClient } = useClient(editPripomienka);
  const { getFieldErrorMessage, clearFieldErrorMessage } = useFieldErrorMessages();
  const { cancelAction, visible } = useActionContext();

  useEffect(() => {
    if (visible === true) {
      cancelAction();
    }
    // trigger only on pripomienka change
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pripomienka]);

  const updateField: SafeParameterSetter<SavePripomienka> = (fieldName, value) => {
    setPripomienka(prevState => ({ ...prevState, [fieldName]: value }));
    clearFieldErrorMessage(fieldName);
  };

  const handleReset = (): void => {
    navigate(routes.pripomienky.detail.withParams(type, year, index, uuid));
  };

  const handleSubmit = async (): Promise<void> => {
    await wrapClient(
      type,
      year,
      index,
      uuid,
      pripomienka,
    );
    navigate(routes.pripomienky.detail.withParams(type, year, index, uuid));
    displaySuccess('Pripomienka bola úspešne upravená.');
  };
  return (
    <>
      <PripomienkaDetailRow header="Názov LP:" data={legislationProcess?.nazovPredpisu} />
      <section className="organizacia-pripomienky-section">
        <Row className="row-heading">
          <Col width="one-quarter">
            <Heading size="m">PRIPOMIENKOVATEĽ</Heading>
          </Col>
        </Row>
        <PripomienkaDetailRow
          header="Pripomienkujúci subjekt:"
          data={pripomienkaDetail?.pripomienkujuciSubjekt?.fullName}
        />
      </section>
      <section className="udaje-pripomienky-section">
        <Row className="row-heading">
          <Col>
            <Heading size="m">ÚDAJE PRIPOMIENKY</Heading>
          </Col>
        </Row>
        {pripomienkaDetail && (
          <EditPripomienkaForm
            getFieldErrorMessage={getFieldErrorMessage}
            onUpdateField={updateField}
            onSubmit={handleSubmit}
            onReset={handleReset}
            saveLoading={status.loading}
            pripomienkaDetail={pripomienkaDetail}
            updatedPripomienka={pripomienka}
          />
        )}
      </section>
    </>
  );
};

export default EditPripomienkaComponent;
